import { render, staticRenderFns } from "./ExtendOtherNutrientsCopper.vue?vue&type=template&id=0e5fc59d&scoped=true"
import script from "./ExtendOtherNutrientsCopper.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsCopper.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsCopper.vue?vue&type=style&index=0&id=0e5fc59d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5fc59d",
  null
  
)

export default component.exports